package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp


@Composable
fun ProfilePictureSection(
    name: String,
    modifier: Modifier = Modifier
//    isEditView: MutableState<Boolean>,
//    btnText: String,
//    onUploadClick: () -> Unit
) {
    val firstLetter = name.firstOrNull()?.uppercaseChar()?.toString() ?: ""
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = modifier
    ) {
        Box(
            modifier = modifier
                .fillMaxSize()
                .background(BlueApp)
                .padding(10.toScaleDp()),
            contentAlignment = Alignment.Center
        ) {
//            Image(
//                painterResource(Res.drawable.avatar_female),
//                contentDescription = null
//            )
            androidx.compose.material3.Text(
                text = firstLetter,
                color = Color.White,
                fontSize = 50.toScaleSp(),
                textAlign = TextAlign.Center,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        Spacer(modifier = Modifier.height(10.toScaleDp()))
//        if (isEditView.value) {
//            OutlinedButton(
//                border = BorderStroke(1.toScaleDp(), BlueApp),
//                shape = RoundedCornerShape(4.toScaleDp()),
//                onClick = {
//                    onUploadClick()
//                }) {
//                Text(
//                    text = btnText,
//                    color = BlueApp,
//                    fontSize = 14.toScaleSp()
//                )
//            }
//        }
    }
}
